import moment from "moment";
import { useEffect, useState } from "react";
import {
  LineChart,
  CartesianGrid,
  XAxis,
  Tooltip,
  Line,
  ResponsiveContainer,
} from "recharts";

// const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

const Chart = ({ pointsByDates, width, dataKey = "points" }) => {
  const [chartData, setChartData] = useState([]);
  const [ticks, setTicks] = useState([]);

  useEffect(() => {
    const data = Object.entries(pointsByDates).map(([date, points]) => ({
      name: moment(date).format("DD MMM"),
      [dataKey]: +points,
    }));
    setChartData(data);
  }, [pointsByDates, dataKey]);

  useEffect(() => {
    const data = Object.entries(pointsByDates)
      .map(([date, points]) => ({
        name: moment(date).format("DD MMM"),
        [dataKey]: +points,
      }));
    setChartData(data);
  }, [pointsByDates, dataKey]);

  useEffect(() => {
    if (!chartData.length) {
      setTicks([]);
      return;
    }

    const w = Number(width) || 600;

    const labels = chartData.map(d => d.name);
    const avgLen = labels.reduce((s, v) => s + (v?.length || 0), 0) / Math.max(1, labels.length);
    const fontSize = 13;
    const charW = fontSize * 0.6;
    let minLabelPx = avgLen * charW + 16;

    if (w < 700) minLabelPx *= 1.2;
    if (w < 520) minLabelPx *= 1.35;

    minLabelPx = Math.max(70, Math.min(140, minLabelPx));

    const desiredTickCount = Math.max(2, Math.min(12, Math.floor(w / minLabelPx)));

    if (labels.length <= desiredTickCount) {
      setTicks(labels);
      return;
    }

    const lastIdx = labels.length - 1;

    const rawStep = lastIdx / (desiredTickCount - 1);

    const baseCandidates = [
      Math.floor(rawStep),
      Math.round(rawStep),
      Math.ceil(rawStep),
      Math.max(1, Math.floor(rawStep * 0.8)),
      Math.ceil(rawStep * 1.2),
      1, 2, 3, 4, 5, 6, 8, 10, 12, 15
    ];

    const candidates = [...new Set(baseCandidates.filter(n => Number.isFinite(n) && n >= 1))];

    const prefer = new Set([2,3,5,10,12]);
    const pick = candidates.reduce((best, s) => {
      const diff = Math.abs(s - rawStep);
      const remainder = lastIdx % s;
      const penalty = remainder === 0 ? -0.6 : (remainder / s) * 0.3;
      const bonus = prefer.has(s) ? -0.05 : 0;
      const score = diff + penalty + bonus;
      return (best == null || score < best.score) ? { step: s, score } : best;
    }, null);

    const step = Math.max(1, pick?.step || Math.ceil(rawStep));

    const picked = [];
    for (let i = 0; i <= lastIdx; i += step) picked.push(labels[i]);
    if (picked[picked.length - 1] !== labels[lastIdx]) picked.push(labels[lastIdx]);

    setTicks(picked);
  }, [chartData, width]);

  return (
    <div style={{ width: "100%", maxHeight: "300px", height: "100%" }}>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart
          data={chartData}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            ticks={ticks}
            tick={{ fontSize: 13 }}
            tickMargin={1}
            minTickGap={0}
          />
          {
            dataKey === 'adherence' ? (
              <Tooltip formatter={(value) => `${(value * 100).toFixed()}%`} />
            ) : (
              <Tooltip animationDuration={50} />
            )
          }
          <Line
            type="linear"
            dataKey={dataKey}
            isAnimationActive={false}
            stroke="#000"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Chart;